import * as React from 'react';
import type { BlogPosting, Person, WithContext } from 'schema-dts';

import type { SanityBlogPostOrCaseStudy } from '#/lib/sanity/queries/blogPost';
import { blocksToText } from '#/lib/sanity/utils';

import { schemaOrganization } from './consts';
import { RenderSEOSchema } from './Render';

export function ArticleSchema({
  title,
  author,
  href,
  excerpt,
  publishedAt,
  _updatedAt,
  thumbnailImage,
  content,
  category,
}: SanityBlogPostOrCaseStudy) {
  const articleBody = blocksToText(content);

  const authorsSchema: Array<Person> = author.map((author) => ({
    '@type': 'Person',
    name: author.name,
    url: `https://transcend.io${author.href}`,
    role: author.role,
    image: author.avatar.url,
  }));

  const schemaData: WithContext<BlogPosting> = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    url: `https://transcend.io${href}`,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://transcend.io${href}`,
    },
    publisher: schemaOrganization,
    isPartOf: {
      '@id': 'https://transcend.io/#website',
    },
    about: {
      '@id': 'https://transcend.io/#organization',
    },
    articleBody,
    headline: title,
    description: excerpt,
    author: authorsSchema,
    datePublished: publishedAt,
    dateModified: _updatedAt,
    image: {
      '@type': 'ImageObject',
      url: thumbnailImage.url,
    },
    keywords: category.map((cat) => cat.title).join(', '),
    wordCount: articleBody.split(' ').length,
  };

  return <RenderSEOSchema schemaData={schemaData} />;
}
